// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_n3-0";
export var animationContainer = "_n3-1";
export var itemPrice = "_n3-a";
export var itemizedContent = "_n3-9";
export var itemizedHeader = "_n3-7";
export var itemizedRow = "_n3-8";
export var itemizedSection = "_n3-6";
export var modalContent = "_n3-2";
export var orderName = "_n3-3";
export var refundOption = "_n3-4";
export var refundOptionsContainer = "_n3-5";
export var shippingLabel = "_n3-b";
export var totalRow = "_n3-c";